import { CommonModule } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { DotLoaderComponent } from '../dot-loader/dot-loader.component';

@Component({
  selector: 'dc-loading-page',
  standalone: true,
  imports: [CommonModule, DotLoaderComponent],
  templateUrl: './loading-page.component.html',
  styleUrl: './loading-page.component.scss'
})
export class LoadingPageComponent {
  message = input('Loading...');
  logoPath = signal('denticare/inverted_logo.svg');
}
